<div class="grid-x bold-text" *ngFor="let nameServer of nameServers" [ngClass]="nsChange| defineDomainViewCss: nameServer: 'nameServer'">
  <div class="cell large-4 medium-4 small-12" style="display: flex; align-items: center"><span>{{nameServer.hostname}}</span>
    <fa-icon *ngIf="nameServer.shared" [icon]="'info-circle'" style="font-size: 8px; padding-left: 5px"></fa-icon>
  </div>
  <div class="cell large-8 medium-8 small-12">
            <span class="ipaddress-separator" *ngFor="let ip of nameServer.ipAddresses | sortIpUtil">
            {{ip}}
            </span>
  </div>
</div>
<div class="grid-x header-helper" style="margin-top: 8px; display: flex; align-items: center" *ngIf="hasSharedNameServers">
  <fa-icon [icon]="'info-circle'" style="font-size: 8px; padding-right: 8px"></fa-icon>
  Name server is shared by other domains. Other parties may need to take action on this request before these name server changes can be implemented.
</div>
<div class="grid-x last-update-button-section">
  <label>{{lastchange | lastChange}}</label>
  <button *ngIf="!viewMode" class="iana-button" id="update" (click)="updateNameServers()" [disabled]="!(pendingRequestChangeID | checkNull)">Modify</button>
</div>

